import {
    addSlide,
    checkIsAllPhotosUploaded,
    setIsAllPhotosUploaded,
    setOnBoardingShowReorderPopup
} from "../store/makerDataSlice";
import SlideData, {UploadStatus} from "../Interfaces/SlideData";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import axios from "axios";
import {addTextUrl} from "./url";
import ym from "react-yandex-metrika";
import promoCodeApply from "./promoCodeApply";
import {store} from "../store/store";

export default async function addText(argsData: any) {

    let text = argsData.text;
    let dispatch = argsData.dispatch;
    let tmpProjectId = argsData.tmpProjectId;
    let pid: string = argsData.pid;
    let makerData = argsData.makerData;

    let vkLaunchParams = {};
    if (makerData?.vkLaunchParams?.vk_app_id) {
        for (const [key, value] of Object.entries(makerData.vkLaunchParams)) {
            // @ts-ignore
            vkLaunchParams[key] = value;
        }
    }

    dispatch(setIsAllPhotosUploaded(false));

    dispatch(addSlide({
        pid: pid,
        type: 'text',
        status: UploadStatus.uploading
    } as SlideData));
    const MySwal = withReactContent(Swal)
    MySwal.close()
    const postData = {
        text: text,
        pid: pid,
        tmpProjectId: tmpProjectId
    };

    const response = await axios.post(
        addTextUrl,
        postData,
        {
            params: vkLaunchParams,
        }
    );
    if (response.data.result == 'ok') {
        await dispatch(addSlide({
            pid: response.data.pid,
            previewId: response.data.previewId,
            src: response.data.url,
            medium_url: response.data.thumbnail_url,
            thumbnail_url: response.data.thumbnail_url,
            pathInfoFilename: response.data.pathInfoFilename,
            type: 'text',
            text: response.data.text,
            status: UploadStatus.ready,
            createdAt: Math.round(new Date().getTime() / 1000),
            createdByUser: true
        } as SlideData));
        const makerData2 = store.getState().makerData;
        if (typeof makerData2.onBoardingShowReorderPopup === 'undefined' && makerData2.currentTab === 'slides') {
            dispatch(setOnBoardingShowReorderPopup(true));
        }
        dispatch(checkIsAllPhotosUploaded());
        // для тестировщиков VK, чтобы могли проверить оплату, за 1 руб
        if (response.data.text.trim().toLowerCase() == 'vktest') {
            promoCodeApply({
                promoCode: 'VKTEST',
                themeId: '',
                slidesNum: 0,
                dispatch: dispatch
            });
        }
        ym('reachGoal', 'addTextSlideSuccess');
    } else {
        throw ({
            message: 'Failed to add text. Error in response.',
            response: response,
            responseConfig: JSON.stringify(response?.config),
            responseData: JSON.stringify(response?.data),
            url: addTextUrl
        });
    }
}